var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article" }, [_vm._v("文章添加编辑同一页面")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }